const smartId = require('./smart-id')
const { byId } = require('./by-id')

module.exports = {
  byId,
  smartId
}
